module.exports = __webpack_public_path__ + "img/inrule.aee36f09.png";